'use client';
import * as React from 'react';
import { createContext, useContext, useMemo, useState } from 'react';
import { PaymentMethod } from '../constants/paymentMethod';

export interface PaymentProviderProps {
  paymentType: string;
  paymentDetails: {
    saleId: string;
  };
}

export interface PaymentContextType {
  paymentDetails: PaymentProviderProps;
  setPaymentDetails(f: PaymentProviderProps | ((prev: PaymentProviderProps) => PaymentProviderProps)): void;
}

const PaymentDetailsContext = createContext<PaymentContextType>({} as PaymentContextType);

export const usePaymentDetails = () => {
  return useContext(PaymentDetailsContext);
};

export const PaymentDetailsProvider = ({ children }: { children: React.ReactNode }) => {
  const [paymentDetails, setPaymentDetails] = useState<PaymentProviderProps>({
    paymentType: PaymentMethod.crypto,
    paymentDetails: {
      saleId: ''
    }
  });

  const values = useMemo<PaymentContextType>(() => {
    return {
      paymentDetails,
      setPaymentDetails
    } as PaymentContextType;
  }, [paymentDetails, setPaymentDetails]);

  return <PaymentDetailsContext.Provider value={values}>{children}</PaymentDetailsContext.Provider>;
};
